import { RouteSegments } from 'constants/routes';
import { NullishPartial } from 'types/typeutils';

export const toRelativeRoute = (route: string) => route.replace(/^\//, '');

export type SegmentValues = NullishPartial<
	Record<RouteSegments, string | number>
>;
export const fillSegments = (route: string, segmentsValues: SegmentValues) => {
	let res = route;
	for (const [segmentKey, segmentVal] of Object.entries(segmentsValues).filter(
		([, v]) => v !== null && v !== undefined
	)) {
		res = res.replace(`:${segmentKey}`, segmentVal!.toString());
	}

	return res;
};

export const filterSearchParams = (
	searchParams: URLSearchParams,
	paramsToPreserve: string[]
) =>
	new URLSearchParams(
		paramsToPreserve
			.map((param) => [param, searchParams.get(param)])
			.filter(([, value]) => value !== null) as [string, string][]
	);
